/**
 * Templates AI Edit Feature
 *
 * Feature for AI-powered creation of note templates from documents.
 * Uses AG-UI protocol for streaming chat interactions.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { templatesAiEditFeature } from './store/feature';

// Auto-register feature on module load
autoRegisterFeature(templatesAiEditFeature);

// Export public API
export * from './components';
export * from './hooks';
export * from './routes';
export * from './store';
export type * from './types';

